<div *transloco="let t" class="flex h-full max-h-full flex-col gap-2">
  <div
    class="flex min-h-0 w-full flex-1 flex-col rounded-md bg-white"
    [class.border]="bordered()"
    data-testid="asin-selection-container"
  >
    <div class="flex w-full border-b p-4">
      <div class="flex flex-1 items-center justify-between gap-4">
        <div class="flex flex-1 items-center gap-4">
          @if (!readonly()) {
            <ICheckbox
              [value]="isAllSelected()"
              [indeterminate]="isCheckboxIndeterminate()"
              (valueChange)="selectAllChange()"
              [disabled]="filteredProductList().size === 0"
              [iTooltip]="checkboxAllTooltip()"
            />
          }
          <div iInputGroup>
            <IIcon name="search" />
            <input
              iInputGroupInput
              [placeholder]="t('drag-drop-asins.search_by_asin_or_product_title')"
              size="sm"
              class="flex-1"
              [ngModel]="searchFilter()"
              (ngModelChange)="onSearch($event)"
              name="searchFilter"
            />
          </div>
        </div>
        <div class="flex items-center gap-2">
          <app-compact-filter [filters]="filters() ?? []" (filterChange)="onFilterChange($event)" />
          @if (csvExport()) {
            <button iButton variant="secondary" (click)="exportCsv()">
              <IIcon name="upload" />
              {{ t("common.export") }}
            </button>
          }
          @if (!readonly() && withBulk()) {
            <button iButton variant="secondary" testId="btn-bulk-asin" (click)="openBulkAsinModal()">
              {{ bulkButtonLabel() }}
            </button>
          }
          @if (withGroupByParent()) {
            <button iButton variant="secondary" (click)="groupByParentAsin.set(!groupByParentAsin())">
              {{
                !groupByParentAsin()
                  ? t("product-tracker.group_by_parent_asin")
                  : t("product-tracker.split_by_child_asin")
              }}
            </button>
          }
        </div>
      </div>
    </div>
    <div class="scrollbar flex min-h-0 flex-1 flex-col">
      @if (!isLoading() && !noCatalog()) {
        @for (product of paginatedProductList() | keyvalue; track product.key.asin) {
          @if (groupByParentAsin() && product.key.isParent) {
            <app-asin-selection-row
              [product]="product.key"
              [readonly]="readonly()"
              [groupByParentAsin]="groupByParentAsin()"
              [openedParentAsin]="openedParentAsin()"
              [asinsLimitReached]="hasReachedAsinLimit()"
              [asinsLimit]="asinsLimit()"
              (productClicked)="onProductClick(product.key)"
              (openParentAsinClicked)="setOpenParentAsin($event)"
              (restoreToManagedCatalogClicked)="restoreToManagedCatalog(product.key)"
            />
          }
          <div
            [ngClass]="{
              'pl-11': groupByParentAsin(),
              'grid transition-all duration-200': groupByParentAsin(),
            }"
            [ngStyle]="{
              'grid-template-rows': groupByParentAsin() && openedParentAsin() === product.key.asin ? '1fr' : '0fr',
            }"
          >
            <div [ngClass]="{ 'overflow-hidden': groupByParentAsin() }">
              @for (child of product.value; track child.asin) {
                <app-asin-selection-row
                  [product]="child"
                  [readonly]="readonly()"
                  [groupByParentAsin]="groupByParentAsin()"
                  [openedParentAsin]="openedParentAsin()"
                  [asinsLimitReached]="hasReachedAsinLimit()"
                  [asinsLimit]="asinsLimit()"
                  (productClicked)="onProductClick(child)"
                  (restoreToManagedCatalogClicked)="restoreToManagedCatalog(child)"
                />
              }
            </div>
          </div>
        } @empty {
          <div class="flex flex-1 flex-col items-center justify-center py-4">
            <IEmptyState
              [title]="t('selling-partner-integration-validation-modal.no_product_has_been_found')"
              [description]="t('selling-partner-integration-validation-modal.no_product_has_been_found')"
            />
          </div>
        }
      } @else {
        <div class="flex flex-1 flex-col items-center justify-center py-4">
          @if (noCatalog()) {
            <IEmptyState
              [title]="t('selling-partner-integration-validation-modal.no_product_has_been_found')"
              [description]="t('strategy-asins.no_catalog_product_for_marketplace')"
            />
          } @else {
            <ISpinner [display]="true" />
          }
        </div>
      }
    </div>
    <div
      class="group flex h-12 w-full shrink-0 items-center justify-between overflow-hidden border-t border-gray-200 px-4 py-2"
    >
      <div class="flex flex-row items-center gap-2">
        <span class="text-sm text-gray-400">{{ t("common.results", { count: filteredProductLength() }) }}</span>
        <div
          class="flex cursor-pointer items-center gap-1"
          [ngClass]="onlySelectedFilter() ? 'text-main-500 font-medium' : 'text-gray-600 hover:text-gray-900'"
          (click)="onlySelectedFilter.set(!onlySelectedFilter())"
          [iTooltip]="t('asins-selection.filter_selected_products')"
        >
          <span class="text-sm">{{ t("common.selected", { count: selectedProductList().length }) }}</span>
          <IIcon name="filter" />
        </div>
      </div>

      @if (filteredProductLength() > DEFAULT_PAGE_SIZE) {
        <IPaginator
          [length]="filteredProductLength()"
          [pageIndex]="pagination().pageIndex"
          [pageSize]="DEFAULT_PAGE_SIZE"
          (paginationEvent)="pagination.set($event)"
          [displayPageSizeOptions]="false"
        />
      }
    </div>
  </div>
</div>
